import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  pageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

const fontFamily = "system-ui, 'Segoe UI', Roboto, sans-serif";

const lightPageTheme = {
  ...pageTheme,
  home: genPageTheme({
    colors: ['#6a39ff', '#3a95de'],
    shape: shapes.wave,
  }),
  website: genPageTheme({
    colors: ['#5d49e2', '#3f84df'],
    shape: shapes.wave,
  }),
  Website: genPageTheme({
    colors: ['#5d49e2', '#3f84df'],
    shape: shapes.wave,
  }),
  WEBSITE: genPageTheme({
    colors: ['#5d49e2', '#3f84df'],
    shape: shapes.wave,
  }),
  service: genPageTheme({
    colors: ['#4d5bd8', '#3a95de'],
    shape: shapes.wave,
  }),
  apis: genPageTheme({
    colors: ['#4a68dd', '#3a95de'],
    shape: shapes.wave2,
  }),
  card: genPageTheme({
    colors: ['#5b4ce6', '#3f84df'],
    shape: shapes.wave,
  }),
  system: genPageTheme({
    colors: ['#4d5bd8', '#3a95de'],
    shape: shapes.wave,
  }),
  System: genPageTheme({
    colors: ['#4d5bd8', '#3a95de'],
    shape: shapes.wave,
  }),
  SYSTEM: genPageTheme({
    colors: ['#4d5bd8', '#3a95de'],
    shape: shapes.wave,
  }),
  grpc: genPageTheme({
    colors: ['#4a68dd', '#3a95de'],
    shape: shapes.wave,
  }),
  Grpc: genPageTheme({
    colors: ['#4a68dd', '#3a95de'],
    shape: shapes.wave,
  }),
  GRPC: genPageTheme({
    colors: ['#4a68dd', '#3a95de'],
    shape: shapes.wave,
  }),
};

const darkPageTheme = {
  ...pageTheme,
  home: genPageTheme({
    colors: ['#5b33d4', '#2f73c9'],
    shape: shapes.wave,
  }),
  website: genPageTheme({
    colors: ['#5235be', '#3a74c4'],
    shape: shapes.wave,
  }),
  Website: genPageTheme({
    colors: ['#5235be', '#3a74c4'],
    shape: shapes.wave,
  }),
  WEBSITE: genPageTheme({
    colors: ['#5235be', '#3a74c4'],
    shape: shapes.wave,
  }),
  service: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  apis: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave2,
  }),
  card: genPageTheme({
    colors: ['#5235be', '#3a74c4'],
    shape: shapes.wave,
  }),
  system: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  System: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  SYSTEM: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  grpc: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  Grpc: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
  GRPC: genPageTheme({
    colors: ['#4a33af', '#2f73c9'],
    shape: shapes.wave,
  }),
};

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.light,
    pageTheme: lightPageTheme,
  }),
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme: lightPageTheme,
  palette: {
    ...palettes.light,
    primary: {
      ...palettes.light.primary,
      main: '#3f84df',
    },
    background: {
      ...palettes.light.background,
      default: '#fff',
      paper: '#fff',
    },
    text: {
      primary: '#08060d',
    },
  },
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: palettes.dark,
    pageTheme: darkPageTheme,
  }),
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme: darkPageTheme,
  palette: {
    ...palettes.dark,
    primary: {
      ...palettes.dark.primary,
      main: '#5f8ee8',
    },
    background: {
      ...palettes.dark.background,
      default: '#16171d',
      paper: '#1f2028',
    },
    text: {
      primary: '#f3f4f6',
    },
  },
});
